import { Action } from '@ngrx/store';
import { Account } from '../../account/store/account.model';
import { LocaleEnum } from '../../expenses/expense-enums';
import { PayrollItem } from '../../payroll/item/store/payroll-item.model';
import { IUserInfo } from '../../user-info/IUserInfo';
import { Color } from '../color.model';
import { IAuthorizationClass } from '../IAuthorizationClass';
import { IAuthorizationType } from '../IAuthorizationType';
import { IContractType } from '../IContractType';
import { IDayOfWeek } from '../IDayOfWeek';
import { IDirectReport } from '../IDirectReport';
import { IEntityFilter } from '../IEntityFilter';
import { IExpenseItem } from '../IExpenseItem';
import { ILocale } from '../ILocale';
import { ILocation } from '../ILocation';
import { IndirectType } from '../IndirectType';
import { IPerDiemLocale } from '../IPerDiemLocal';
import { IServiceItem } from '../IServiceItem';
import { ISplitDay } from '../ISplitDay';
import { IState } from '../IState';
import { ITask } from '../ITask';
import { ITimeZone } from '../ITimeZone';
import { ITravelType } from '../ITravelType';
import { IUserIdFormat } from '../iuser-id-format';
import { IUserGroup } from '../IUserGroup';
import { MessageDeliveryType } from '../message-delivery-type.model';
import { MobileProvider } from '../mobile-provider.model';

export enum LookupActionTypes {
    RESET = '[lookup] RESET',
    LoadAuthorizationTypes = '[lookup] Load Authorization Types',
    LoadDirectReports = '[lookup] Load Direct Reports',
    LoadTasks = '[lookup] Load Tasks',
    LoadUserTasks = '[lookup] Load User Tasks',
    LoadContractTasks = '[lookup] Load Contract Tasks',
    LoadServiceItems = '[lookup] Load Service Items',
    LoadUserGroups = '[lookup] Load User Groups',
    LoadAuthorizationClasses = '[lookup] Load Authorization Classes',
    LoadPayrollItems = '[lookup] Load Payroll Items',
    LoadPerDiemTypes = '[lookup] Load Per Diem Types',
    LoadLocales = '[lookup] Load Locales',
    LoadTravelTypes = '[lookup] Load Travel Types',
    LoadExpenseItems = '[lookup] Load Expense Items',
    LoadStates = '[lookup] Load States',
    LoadCountries = '[lookup] Load Countries',
    LoadAreas = '[lookup] Load Areas',
    LoadLocations = '[lookup] Load Locations',
    LoadContractTypes = '[lookup] Load Contract Types',
    LoadEntityFilter = '[lookup] Load Entity Filter',
    LoadSplitday = '[lookup] Load Splitday',
    LoadIndirectTypes = '[lookup] Load Indirect Types',
    LoadPayrollFrequency = '[lookup] Load Payroll Frequency',
    LoadUserIdFormats = '[lookup] Load User Id Formats',
    LoadDaysOfWeek = '[lookup] Load Days Of Week',
    LoadTimeZones = '[lookup] Load Time Zones',
    LoadUserTimeZones = '[lookup] Load User Time Zones',
    LoadColors = '[lookup] Load Colors',
    LoadMobileProviders = '[lookup] LoadMobileProviders',
    SetAuthorizationTypes = '[lookup] Set Authorization Types',
    SetDirectReports = '[lookup] Set Direct Reports',
    SetTasks = '[lookup] Set Tasks',
    SetUserTasks = '[lookup] Set User Tasks',
    SetContractTasks = '[lookup] Set Contract Tasks',
    SetServiceItems = '[lookup] Set Service Items',
    SetUserGroups = '[lookup] Set User Groups',
    SetAuthorizationClasses = '[lookup] Set Authorization Classes',
    SetPayrollItems = '[lookup] Set Payroll Items',
    SetPerDiemTypes = '[lookup] Set Per Diem Types',
    SetLocales = '[lookup] Set Locales',
    SetTravelTypes = '[lookup] Set Travel Types',
    SetExpenseItems = '[lookup] Set Expense Items',
    SetStates = '[lookup] Set States',
    SetCountries = '[lookup] Set Countries',
    SetAreas = '[lookup] Set Areas',
    SetLocations = '[lookup] Set Locations',
    SetContractTypes = '[lookup] Set Contract Types',
    SetIndirectTypes = '[lookup] Set Indirect Types',
    SetEntityFilter = '[lookup] Set Entity Filter',
    SetSplitday = '[lookup] Set Splitday',
    SetPayrollFrequency = '[lookup] Set Payroll Frequency',
    SetUserIdFormats = '[lookup] Set User Id Formats',
    SetDaysOfWeek = '[lookup] Set Days Of Week',
    SetTimeZones = '[lookup] Set Time Zones',
    SetUserTimeZones = '[lookup] Set User Time Zones',
    SetColors = '[lookup] Set Colors',
    SetMobileProviders = '[lookup] Set SetMobileProviders',
    GetCreditCards = '[lookup] Get Credit Cards',
    SetCreditCards = '[lookup] Set Credit Cards',
    GetMessageDeliveryTypes = '[lookup] Get Message Delivery Types',
    SetMessageDeliveryTypes = '[lookup] Set Message Delivery Types'
}
export class Reset implements Action {
    readonly type = LookupActionTypes.RESET;
}
export class LoadDirectReports implements Action {
    readonly type = LookupActionTypes.LoadDirectReports;
    constructor(
        public payload: {
            user: IUserInfo;
            activeOnly: boolean;
            processId?: number;
            MyDRsOnly?: boolean;
        }
    ) {}
}

export class SetDirectReports implements Action {
    readonly type = LookupActionTypes.SetDirectReports;
    constructor(public payload: Array<IDirectReport>) {}
}

export class LoadAuthorizationTypes implements Action {
    readonly type = LookupActionTypes.LoadAuthorizationTypes;
}
export class SetAuthorizationTypes implements Action {
    constructor(public payload: Array<IAuthorizationType>) {}
    readonly type = LookupActionTypes.SetAuthorizationTypes;
}

export class LoadTasks implements Action {
    readonly type = LookupActionTypes.LoadTasks;
}
export class SetTasks implements Action {
    constructor(public payload: Array<ITask>) {}
    readonly type = LookupActionTypes.SetTasks;
}

export class LoadUserTasks implements Action {
    readonly type = LookupActionTypes.LoadUserTasks;
    constructor(public payload: { ProcessID: number; AsOfDate: Date }) {}
}
export class LoadContractTasks implements Action {
    readonly type = LookupActionTypes.LoadContractTasks;
    constructor(public payload: { contractlistid: string }) {}
}
export class SetUserTasks implements Action {
    constructor(public payload: Array<ITask>) {}
    readonly type = LookupActionTypes.SetUserTasks;
}
export class SetContractTasks implements Action {
    constructor(public payload: Array<ITask>) {}
    readonly type = LookupActionTypes.SetContractTasks;
}

export class LoadServiceItems implements Action {
    constructor(
        public activeOnly?: boolean,
        public IncludeSystem: boolean = false,
        public IncludeOtherChargeItem: boolean = false
    ) {}
    readonly type = LookupActionTypes.LoadServiceItems;
}
export class SetServiceItems implements Action {
    constructor(public payload: Array<IServiceItem>) {}
    readonly type = LookupActionTypes.SetServiceItems;
}
export class LoadUserGroups implements Action {
    readonly type = LookupActionTypes.LoadUserGroups;
}
export class SetUserGroups implements Action {
    constructor(public payload: Array<IUserGroup>) {}
    readonly type = LookupActionTypes.SetUserGroups;
}
export class LoadEntityFilter implements Action {
    readonly type = LookupActionTypes.LoadEntityFilter;
    constructor(public filterEntity: string) {}
}
export class SetEntityFilter implements Action {
    readonly type = LookupActionTypes.SetEntityFilter;
    constructor(public filterTypes: Array<IEntityFilter>) {}
}
export class LoadAuthorizationClasses implements Action {
    readonly type = LookupActionTypes.LoadAuthorizationClasses;
}
export class SetAuthorizationClasses implements Action {
    constructor(public payload: Array<IAuthorizationClass>) {}
    readonly type = LookupActionTypes.SetAuthorizationClasses;
}

export class LoadPayrollItems implements Action {
    constructor(public payload?: Array<string>) {}
    readonly type = LookupActionTypes.LoadPayrollItems;
}
export class SetPayrollItems implements Action {
    constructor(public payload: Array<PayrollItem>) {}
    readonly type = LookupActionTypes.SetPayrollItems;
}
export class LoadPerDiemTypes implements Action {
    readonly type = LookupActionTypes.LoadPerDiemTypes;
}
export class SetPerDiemTypes implements Action {
    readonly type = LookupActionTypes.SetPerDiemTypes;
    constructor(public payload: Array<IPerDiemLocale>) {}
}
export class LoadLocales implements Action {
    readonly type = LookupActionTypes.LoadLocales;
}
export class SetLocales implements Action {
    readonly type = LookupActionTypes.SetLocales;
    constructor(public payload: Array<ILocale>) {}
}

export class LoadTravelTypes implements Action {
    readonly type = LookupActionTypes.LoadTravelTypes;
}
export class SetTravelTypes implements Action {
    readonly type = LookupActionTypes.SetTravelTypes;
    constructor(public payload: Array<ITravelType>) {}
}
export class LoadExpenseItems implements Action {
    readonly type = LookupActionTypes.LoadExpenseItems;
}
export class SetExpenseItems implements Action {
    readonly type = LookupActionTypes.SetExpenseItems;
    constructor(public payload: Array<IExpenseItem>) {}
}
export class LoadStates implements Action {
    readonly type = LookupActionTypes.LoadStates;
}
export class SetStates implements Action {
    readonly type = LookupActionTypes.SetStates;
    constructor(public payload: Array<IState>) {}
}
export class LoadLocations implements Action {
    readonly type = LookupActionTypes.LoadLocations;
    constructor(public payload: { locale: LocaleEnum; countryArea: string }) {}
}
export class SetLocations implements Action {
    readonly type = LookupActionTypes.SetLocations;
    constructor(public payload: Array<ILocation>) {}
}
export class LoadCountries implements Action {
    readonly type = LookupActionTypes.LoadCountries;
}
export class SetCountries implements Action {
    readonly type = LookupActionTypes.SetCountries;
    constructor(public payload: Array<ILocation>) {}
}
export class LoadAreas implements Action {
    readonly type = LookupActionTypes.LoadAreas;
}
export class SetAreas implements Action {
    readonly type = LookupActionTypes.SetAreas;
    constructor(public payload: Array<ILocation>) {}
}
export class LoadContractTypes implements Action {
    constructor() {}
    readonly type = LookupActionTypes.LoadContractTypes;
}
export class SetContractTypes implements Action {
    constructor(public payload: Array<IContractType>) {}
    readonly type = LookupActionTypes.SetContractTypes;
}
export class LoadIndirectTypes implements Action {
    constructor() {}
    readonly type = LookupActionTypes.LoadIndirectTypes;
}
export class SetIndirectTypes implements Action {
    constructor(public payload: Array<IndirectType>) {}
    readonly type = LookupActionTypes.SetIndirectTypes;
}
export class LoadSplitday implements Action {
    readonly type = LookupActionTypes.LoadSplitday;
}
export class SetSplitday implements Action {
    readonly type = LookupActionTypes.SetSplitday;
    constructor(public payload: Array<ISplitDay>) {}
}
export class LoadPayrollFrequency implements Action {
    readonly type = LookupActionTypes.LoadPayrollFrequency;
}
export class SetPayrollFrequency implements Action {
    readonly type = LookupActionTypes.SetPayrollFrequency;
    constructor(public payload: Array<{ Payrollfrequency: number }>) {}
}
export class LoadUserIdFormats implements Action {
    readonly type = LookupActionTypes.LoadUserIdFormats;
}
export class SetUserIdFormats implements Action {
    readonly type = LookupActionTypes.SetUserIdFormats;
    constructor(public payload: Array<IUserIdFormat>) {}
}
export class LoadDaysOfWeek implements Action {
    readonly type = LookupActionTypes.LoadDaysOfWeek;
}
export class SetDaysOfWeek implements Action {
    readonly type = LookupActionTypes.SetDaysOfWeek;
    constructor(public payload: Array<IDayOfWeek>) {}
}
export class LoadTimeZones implements Action {
    readonly type = LookupActionTypes.LoadTimeZones;
}
export class SetTimeZones implements Action {
    readonly type = LookupActionTypes.SetTimeZones;
    constructor(public payload: Array<ITimeZone>) {}
}
export class LoadUserTimeZones implements Action {
    readonly type = LookupActionTypes.LoadUserTimeZones;
}
export class SetUserTimeZones implements Action {
    readonly type = LookupActionTypes.SetUserTimeZones;
    constructor(public payload: Array<ITimeZone>) {}
}
export class LoadColors implements Action {
    readonly type = LookupActionTypes.LoadColors;
}
export class SetColors implements Action {
    readonly type = LookupActionTypes.SetColors;
    constructor(public payload: Array<Color>) {}
}
export class LoadMobileProviders implements Action {
    readonly type = LookupActionTypes.LoadMobileProviders;
}
export class SetMobileProviders implements Action {
    readonly type = LookupActionTypes.SetMobileProviders;
    constructor(public payload: Array<MobileProvider>) {}
}
export class GetCreditCards implements Action {
    constructor(public payload: string) {}
    readonly type = LookupActionTypes.GetCreditCards;
}
export class SetCreditCards implements Action {
    constructor(public payload: Account[]) {}
    readonly type = LookupActionTypes.SetCreditCards;
}
export class GetMessageDeliveryTypes implements Action {
    readonly type = LookupActionTypes.GetMessageDeliveryTypes;
}
export class SetMessageDeliveryTypes implements Action {
    constructor(public payload: MessageDeliveryType[]) {}
    readonly type = LookupActionTypes.SetMessageDeliveryTypes;
}
export type LookupActionsUnion =
    | Reset
    | LoadDirectReports
    | LoadAuthorizationTypes
    | LoadTasks
    | LoadUserTasks
    | LoadContractTasks
    | LoadServiceItems
    | LoadUserGroups
    | LoadAuthorizationClasses
    | LoadPayrollItems
    | LoadPerDiemTypes
    | LoadLocales
    | LoadTravelTypes
    | LoadExpenseItems
    | LoadStates
    | LoadCountries
    | LoadAreas
    | LoadLocations
    | LoadContractTypes
    | LoadIndirectTypes
    | LoadEntityFilter
    | LoadSplitday
    | LoadPayrollFrequency
    | LoadUserIdFormats
    | LoadDaysOfWeek
    | LoadTimeZones
    | LoadUserTimeZones
    | LoadColors
    | LoadMobileProviders
    | SetAuthorizationTypes
    | SetDirectReports
    | SetTasks
    | SetUserTasks
    | SetContractTasks
    | SetServiceItems
    | SetUserGroups
    | SetAuthorizationClasses
    | SetPayrollItems
    | SetPerDiemTypes
    | SetLocales
    | SetTravelTypes
    | SetExpenseItems
    | SetStates
    | SetAreas
    | SetCountries
    | SetLocations
    | SetContractTypes
    | SetIndirectTypes
    | SetEntityFilter
    | SetSplitday
    | SetPayrollFrequency
    | SetUserIdFormats
    | SetDaysOfWeek
    | SetTimeZones
    | SetUserTimeZones
    | SetColors
    | SetMobileProviders
    | GetCreditCards
    | SetCreditCards
    | GetMessageDeliveryTypes
    | SetMessageDeliveryTypes;
